import TranCompleteModal from './TranCompleteModal';

export default TranCompleteModal;